<template>
  <el-dialog @close='close' :title="title" :visible.sync="dialogVisible" width="500px">
    <el-form ref="added" :model="formData1" :rules="rules1" size="medium" label-width="100px">
      <el-form-item label="姓名：" prop="user_name">
        <el-input v-model="formData1.user_name" :maxlength='15' show-word-limit placeholder="请输入姓名" clearable
          style="width: 300px;">
        </el-input>
      </el-form-item>
      <el-form-item label="性别：" prop="user_sex">
       <el-radio-group v-model="formData1.user_sex" size="medium">
         <el-radio :label="1">男</el-radio>
         <el-radio :label="2">女</el-radio>
       </el-radio-group>
      </el-form-item>
      <el-form-item label="手机号：" prop="user_phone">
        <el-input type="number"
          @input="formData1.user_phone=formData1.user_phone.length > 11?formData1.user_phone.slice(0, 11):formData1.user_phone"
           v-model="formData1.user_phone" placeholder="请输入手机号" style="width: 300px;">
        </el-input>
      </el-form-item>
      <el-form-item label="身份：" prop="user_role">
       <el-select v-model="formData1.user_role" placeholder="请选择">
           <el-option label="普通用户" :value="1"></el-option>
           <el-option label="社工" :value="2"></el-option>
         </el-select>
      </el-form-item>
      <el-form-item label="所属区域" prop="area_code" v-if="formData1.user_role == 2">
        <el-cascader v-model="formData1.village_code" :options="areaList" clearable :props="{ 
          expandTrigger: 'hover',
          children: 'child',
          label:'area_name',
          value:'area_code'
        }" @change="handleChange"></el-cascader>
      </el-form-item>
      
    </el-form>
    <span class="flex-ct" style="padding-top: 30px;">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="handelConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default{
    data(){
      var validatorPhone = function(rule, value, callback) {
        if (!/^1[23456789]\d{9}$/.test(value)) {
          callback(new Error('手机号格式错误'))
        } else {
          callback()
        }
      }
      return{
        title: "",
        dialogVisible: false,
        formData1: {
          user_id: '',
          user_name: '',
          user_sex: 1,
          area_code: '',
          village_code: '',
          user_phone: '',
          user_role: ''
        },
        rules1: { //弹窗 正则
          user_name: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }],
          user_sex: [{
            required: true,
            message: '请选择性别',
            trigger: ['change', 'blur']
          }],
          user_phone: [{
            required: true,
            message: '请输入手机号：',
            trigger: 'blur'
          }, {
            message: '手机号格式有误',
            validator: validatorPhone,
            trigger: 'blur'
          }],
          area_code: [{
            required: true,
            message: '请选择区域',
            trigger: 'change'
          }],
          user_role: [{
            required: true,
            message: '请选择身份',
            trigger: 'change'
          }],
        },
        areaList: [],
      }
    },
    methods:{
      show(row){
        this.getAreaList()
        if(row){
          this.title = '编辑用户：'+ row.user_name
          this.formData1.user_id = row.user_id
          this.formData1.user_name = row.user_name
          this.formData1.user_sex = row.user_sex == 0 ? '' : row.user_sex
          this.formData1.area_code = row.user_area_code
          this.formData1.village_code = row.user_village_code
          this.formData1.user_phone = row.user_phone
          this.formData1.user_role = row.user_role
        }else{
          this.title = '新增用户'
          this.formData1 = {
            user_id: '',
            user_name: '',
            user_sex: 1,
            area_code: '',
            village_code: '',
            user_phone: '',
            user_role: ''
          }
        }
        this.dialogVisible = true
      },
      close() { //弹窗关闭
        this.$refs['added'].resetFields(); //强制清理表格内容 
        this.dialogVisible = false;
      },
      getAreaList() {
        userInfoAPI.systemSelectionList().then(({
          data
        }) => {
          this.areaList = data.data || []
        })
      },
      handleChange(e) {
        if (e[0]) {
          this.formData1.area_code = e[0]
          this.formData1.village_code = e[1]
        } else {
          this.formData1.area_code = ''
          this.formData1.village_code = ''
        }
      },
      handelConfirm() {
        this.$refs['added'].validate(valid => {
          if (valid) {
            if(this.formData1.user_id){
              userInfoAPI.serviceUserEdit(this.formData1).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.$message({
                    type: 'success',
                    message: data.msg
                  });
                  this.dialogVisible = false
                  this.$emit('success')
                } else {
                  this.$message({
                    type: 'error',
                    message: data.msg
                  })
                }
              })
            }else{
              userInfoAPI.serviceUserAdd(this.formData1).then(({
                data
              }) => {
                if (data.code == 0) {
                  this.$message({
                    type: 'success',
                    message: data.msg
                  });
                  this.dialogVisible = false
                  this.$emit('success')
                } else {
                  this.$message({
                    type: 'error',
                    message: data.msg
                  })
                }
              })
            }
          }
        })
      }
    }
  }
</script>

<style>
</style>